import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check, X } from "lucide-react";

// Shown-once generated password dialog — shared by the Users page and the
// Personnel page's login-access toggle.
// secret: { email, password, title }
export default function PasswordDialog({ secret, onClose }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret.password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Copy failed — select the password manually");
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white border border-[var(--rule-strong)] w-full max-w-md p-6 animate-fade-up" data-testid="password-dialog">
        <button onClick={onClose} className="absolute top-3 right-3 p-1 hover:bg-[var(--paper-soft)]" aria-label="close">
          <X size={14} />
        </button>
        <div className="eyebrow">Shown once</div>
        <h3 className="section-h mt-1 mb-1">{secret.title}</h3>
        <div className="text-xs font-mono-num text-[var(--soft-fg)] mb-5">{secret.email}</div>
        <div className="flex items-stretch border border-[var(--rule-strong)]">
          <code className="flex-1 px-4 py-3 font-mono-num text-lg tracking-wider select-all" data-testid="password-value">
            {secret.password}
          </code>
          <button
            onClick={copy}
            className="px-4 border-l border-[var(--rule-strong)] hover:bg-[var(--paper-soft)] inline-flex items-center gap-2 text-xs font-display tracked-tight uppercase"
            data-testid="copy-password-btn"
          >
            {copied ? <Check size={13} className="text-[#2C4A38]" /> : <Copy size={13} />}
            {copied ? "Copied" : "Copy"}
          </button>
        </div>
        <div className="mt-3 text-xs font-mono-num text-[#6B2F2A]">
          This password cannot be retrieved again. Share it with the user securely.
        </div>
        <div className="flex justify-end mt-6">
          <button onClick={onClose} className="px-4 py-2 bg-[var(--ink)] text-white text-xs font-display tracked-tight uppercase" data-testid="password-dialog-close">
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
